import BeautyInsiderRewardsSummary from './BeautyInsiderRewardsSummary.f';
import { withBeautyInsiderRewardsSummaryProps } from 'viewModel/content/BeautyInsider/withBeautyInsiderRewardsSummaryProps';

export default withBeautyInsiderRewardsSummaryProps(BeautyInsiderRewardsSummary);
